import {
  Box,
  ThemeProvider,
  Pagination as MuiPagination,
  PaginationItem,
} from "@mui/material";
import { theme } from "../SetupProfile/constant";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";

export const Pagination = ({
  totalCount,
  recordsPerPages,
  currentPage,
  onPageChange,
}) => {
  return (
    <ThemeProvider theme={theme}>
      <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
        <MuiPagination
          count={Math.ceil(totalCount / recordsPerPages)}
          showFirstButton
          showLastButton
          page={currentPage}
          onChange={(_, page) => {
            onPageChange(page);
          }}
          sx={{
            "& button": {
              border: "none !important",
            },
          }}
          shape="circular"
          renderItem={(item) => (
            <PaginationItem
              slots={{
                first: MdKeyboardDoubleArrowLeft,
                last: MdKeyboardDoubleArrowRight,
              }}
              {...item}
            />
          )}
        />
      </Box>
    </ThemeProvider>
  );
};
